<template>
    <div>
        <div id="forgot-password" class="wrapper m0-50 critical">
            <div class="section">
                <div class="div-block-15">
                    <div class="form-container">
                        <div class="form-block w-form">
                            <div id="email-form" class="form-wrapper">
                                <div class="form-title-container">
                                    <div class="form-title">Forgot Password</div>
                                    <p>Already have an account? <router-link class="link-blue" v-bind:to="'/login'">Login Now.</router-link></p>
                                </div>
                                <form @submit.prevent="submit">
                                <div class="input-container" :class="{ 'hasError': $v.form.email.$error }">
                                    <label for="email" class="input-label">Email</label>
                                    <input type="email"
                                           class="text-input w-input"
                                           autofocus="true"
                                           maxlength="256" name="email"
                                           v-model="form.email"
                                           @blur="$v.form.email.$touch()"
                                           placeholder="Enter your email..." id="email">
                                    <div class="text-red" v-if="$v.form.email.$error">
                                        <div v-if="!$v.form.email.required">Email is required</div>
                                        <div v-if="!$v.form.email.email">Email is not a properly formatted email address</div>
                                    </div>
                                </div>
                                <button type="submit" data-wait="Please wait..." class="submit-button w-button float-right">Submit</button>
                                </form>
                            </div>
                            <div class="input-container form-success" v-if="success">
                                <div>Thank you! Please check your email for reset password link.</div>
                            </div>
                            <div class="input-container form-fail" v-if="fail">
                                <div>Oops! Something went wrong. If you don't have account please <router-link class="link-blue" v-bind:to="'/register'">register.</router-link></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { userService } from '../assets/js/services/userService';
import { required, email } from "vuelidate/lib/validators";

    export default {
        name: "ForgotPassword",
        data() {
            return {
                form: {
                    email: "",
                },
                success: false,
                fail: false
            }
        },

        validations: {
            form: {
                email: { required, email }
            }
        },

        components: {
        },
        created () {
            document.title = "Forgot Password";//Set the document title
        },
        methods: {
            submit () {
                this.success = false;
                this.fail = false;

                this.$v.form.$touch();
                if(this.$v.form.$error) return;
                // to form submit after this
                userService.forgotPassword(this.form.email)
                    .then(() => {this.success = true;})
                    .catch(() => {this.fail = true;});
            },
        }
    }
</script>

<style scoped>

</style>
